import { isDefined } from "./isDefined";
export var NumberKind;
(function (NumberKind) {
    NumberKind[NumberKind["Currency"] = 0] = "Currency";
    NumberKind[NumberKind["Percent"] = 1] = "Percent";
    NumberKind[NumberKind["Custom"] = 2] = "Custom";
})(NumberKind || (NumberKind = {}));
const insertAbbreviation = (formattedNumber, abbreviation) => {
    // Find the index of the last non-breaking space in the string
    const lastSpaceIndex = formattedNumber.lastIndexOf('\u00A0');
    // If there's no space in the string, return the original string
    if (lastSpaceIndex === -1) {
        return formattedNumber;
    }
    // Insert 'a' at the position of the last space
    return formattedNumber.slice(0, lastSpaceIndex) + abbreviation + formattedNumber.slice(lastSpaceIndex);
};
export const formatCurrency = (price, options) => {
    const { currency, locales, precision } = Object.assign({}, options);
    // default is XXXX kr
    const formatter = new Intl.NumberFormat(locales !== null && locales !== void 0 ? locales : 'pl', { style: 'currency', currency: currency !== null && currency !== void 0 ? currency : 'NOK', currencyDisplay: 'narrowSymbol', maximumFractionDigits: precision !== null && precision !== void 0 ? precision : 0 });
    const formattedNumber = formatter.format(price);
    if (options === null || options === void 0 ? void 0 : options.abbreviation) {
        return insertAbbreviation(formattedNumber, options.abbreviation);
    }
    return formattedNumber;
};
export const format = (value, options) => {
    if (value === null || value === undefined) {
        return '-';
    }
    if (isDefined(options === null || options === void 0 ? void 0 : options.precision)) {
        value = parseFloat(value.toFixed(options === null || options === void 0 ? void 0 : options.precision));
    }
    switch (options === null || options === void 0 ? void 0 : options.type) {
        case NumberKind.Currency:
            if (value >= 1000000 && options.abbreviate) {
                return `${formatCurrency(value / 1000000, { precision: 2, abbreviation: 'M' })}`;
            }
            if (value >= 1000 && options.abbreviate) {
                return `${formatCurrency(value / 1000, { precision: 2, abbreviation: 'K' })}`;
            }
            return formatCurrency(value);
        case NumberKind.Percent:
            return `${value}%`;
        case NumberKind.Custom:
            return `${value} ${options.unit}`;
        default:
            return value.toString(10);
    }
};
